import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import '../../../index.css'
import { carouselCurrentItemSelector } from '../../../selectors'
import NumberFormat from 'react-number-format'
import Loading from 'custom/assets/loaders/Loading'
import BeneficiaryTransferService from '../../../services/beneficiary-transfers.service'
import moment from 'moment'
import LayoutWithOutAccountCard from '../../../layout/Layout/layout-without-card'
import { AUTH_KEYS, RECIPTS_KEYS, REQUESTS_KEYS } from '../../../utils/translation-constants'

export default function Receipts() {
  const history = useHistory()
  const [expanded, setExpanded] = useState(null)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  // const [loadingSideBar, setLoadingSideBar] = useState(false)
  const [stage, setStage] = useState(0)
  const currentAccountDetails = useSelector(carouselCurrentItemSelector)
  const [receiptsList, setReceiptsList] = useState([])

  const receiptsViewDetails = useCallback(async () => {
    try {
      setLoading(true)
      setExpanded(null)
      setStage(0)
      const response = await BeneficiaryTransferService.recieptTransfer()
      if (response.status === 200) {
        setReceiptsList(response.data['receiptDetails'])
      }
      setStage(1)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setStage(1)
      setReceiptsList([])
    }
  }, [currentAccountDetails])

  useEffect(() => {
    receiptsViewDetails()
  }, [])

  const getDownload = useCallback(
    async (selected) => {
      try {
        setLoading(true)
        await BeneficiaryTransferService.downLoadReport(selected)
        setLoading(false)
      } catch (err) {
        setLoading(false)
      }
    },
    [currentAccountDetails],
  )

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderReceiptsViewForm()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderReceiptsViewForm() {
    return (
      <div>
        {loading && renderLoading()}
        {receiptsList.length !== undefined && (
          <div style={{ justifyContent: ' space-between', alignItems: 'center' }}>
            {receiptsList.length !== undefined &&
              receiptsList.map((item, index) => (
                <div
                  key={index}
                  className='loan-card '
                  onClick={() => (expanded === index ? setExpanded(null) : setExpanded(index))}>
                  <div className='loan-header'>
                    <div>
                      <span>{item.destAccount}</span>
                      <div style={{ fontSize: '8px', color: '#777777' }}>
                        {moment(item.transTime).format('DD-MM-YYYY')} &nbsp;{' '}
                        {moment(item.transTime).format('HH:MM:SS')}
                      </div>
                    </div>
                    <div className='d-flex align-items-center justify-space-between'>
                      <div>
                        <label style={{ fontSize: '6px', float: 'left' }}>{item.srcAccCcy}</label>
                        &nbsp;
                        <NumberFormat
                          value={item.amount}
                          displayType={'text'}
                          thousandSeparator={true}
                          prefix={''}
                          className='float-right'
                          fixedDecimalScale={true}
                          decimalScale={2}
                          allowEmptyFormatting
                        />
                      </div>
                      <div>
                        <h6
                          style={{ color: '#F15D2A', marginLeft: '10px' }}
                          onClick={() => getDownload(item)}>
                          {t(RECIPTS_KEYS.DOWNLOAD)}
                        </h6>
                      </div>
                    </div>
                  </div>
                  {expanded === index && (
                    <div className='loan-details'>
                      <div className='row beneficiary-details justify-space-between '>
                        <div className='col-12'>
                          <div className='row'>
                            <div className='col-4'>
                              <div className='label'>
                                {t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.DETAILS_KEYS.USERNAME)}
                              </div>
                              <div className='value'>{item.userName || '-'}</div>
                            </div>
                            <div className='col-4'>
                              <div className='label'>{t(RECIPTS_KEYS.RECEIPT_ID)}</div>
                              <div className='value'>{item.receiptId || '-'}</div>
                            </div>
                            <div className='col-4'>
                              <div className='label'>{t(RECIPTS_KEYS.ACCOUNTNO)}</div>
                              <div className='value'>{item.srcAccount || '-'}</div>
                            </div>
                          </div>

                          <div className='row'>
                            <div className='col-4'>
                              <div className='label'>{t(RECIPTS_KEYS.TRANFER_TYPE)}</div>
                              <div className='value'>{item.transferType || '-'}</div>
                            </div>
                            <div className='col-4'>
                              <div className='label'>{t(RECIPTS_KEYS.TRANSACTION_TIME)}</div>
                              <div className='value'>
                                {moment(item.transTime || '-').format('DD-MM-YYYY')} &nbsp;{' '}
                                {moment(item.transTime || '-').format('HH:MM:SS')}
                              </div>
                            </div>
                            <div className='col-4'>
                              <div className='label'>{t(RECIPTS_KEYS.TRANSACTION)}</div>
                              <div className='value'>{item.transactionRef || '-'}</div>
                            </div>
                          </div>

                          <div className='row'>
                            <div className='col-4'>
                              <div className='label'>{t(RECIPTS_KEYS.SERVICENO)}</div>
                              <div className='value'>{item.serviceNumber || '-'}</div>
                            </div>
                            <div className='col-4'>
                              <div className='label'>
                                {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS1)}
                              </div>
                              <div className='value'>{item.remarks || '-'}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
          </div>
        )}

        {receiptsList.length === 0 && (
          <div className='no-data-found'>{t(RECIPTS_KEYS.NORECEIPTS)}</div>
        )}
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='DOWNLOAD_RECEIPTS'
      showEmptySpace={true}
      keyPath={'RECEIPTS'}>
      {renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
